import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventWhistleRegularStartFirstHalftime extends DomainEvent<MatchEvent> {}
